var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-2 md:px-4 lg:px-10 mx-auto min-h-screen py-24",style:({backgroundColor: _vm.background})},[(_vm.logo)?_c('div',{},[_c('img',{staticClass:"object-cover",attrs:{"src":_vm.logo,"alt":"Logo"}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }